export default __webpack_public_path__ + "images/OQ.27b6cba.png";